var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"label":"Município","items":_vm.municipios,"loading":_vm.municLoading,"item-text":"descricao","item-value":"codigo","no-data-text":"Nenhum município encontrado","dense":_vm.dense,"disabled":_vm.disabled},model:{value:(_vm.municSelecModel),callback:function ($$v) {_vm.municSelecModel=$$v},expression:"municSelecModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }